module.exports = __webpack_public_path__ + "img/Porsche-Travel-Experience_Swiss-Alps_19_low.6390f745.jpg";